// ** Custom Components
import Icon from "components/global/Icon";

// #####################################################

export const distanceListFn = (km) => {
	return [
		{ key: "0", content: () => <Icon>map-marker-alt</Icon>, value: 0 },
		{ key: "1", content: `+20 ${km}`, value: 20 },
		{ key: "2", content: `+50 ${km}`, value: 50 },
		{ key: "3", content: `+100 ${km}`, value: 100 },
		{ key: "4", content: `+200 ${km}`, value: 200 },
	];
};

// #####################################################
